import React, { Fragment, memo } from 'react';

import { TeamsTitleColumn, TeamsTitleRow } from 'ui-lib';
import useTeamsTitle from './useTeamsTitle';

interface Props {
    isPrematchMobileView: boolean;
    startTime: string;
    sportEventId: string;
}

const TeamsTitle: React.FC<Props> = ({
    isPrematchMobileView,
    startTime,
    sportEventId,
}) => {
    const { competitorsValid, isHomeServer, isAwayServer } = useTeamsTitle({
        sportEventId,
    });

    return (
        <Fragment>
            {isPrematchMobileView ? (
                <TeamsTitleColumn
                    competitorsValid={competitorsValid}
                    isHomeServer={isHomeServer}
                    isAwayServer={isAwayServer}
                    startTime={startTime}
                />
            ) : (
                <TeamsTitleRow
                    competitorsValid={competitorsValid}
                    isHomeServer={isHomeServer}
                    isAwayServer={isAwayServer}
                />
            )}
        </Fragment>
    );
};

export default memo(TeamsTitle);
